'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _comparisonTable = require('./comparisonTable.scss');

var _comparisonTable2 = _interopRequireDefault(_comparisonTable);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _arrow = require('-!svg-react-loader!../../../../assets/images/change-provider/arrow.svg');

var _arrow2 = _interopRequireDefault(_arrow);

var _dist = require('wix-style-react/dist/src/Icons/dist');

var _Tooltip = require('wix-style-react/dist/src/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _ChangeProviderLink = require('../ChangeProviderLink');

var _ChangeProviderLink2 = _interopRequireDefault(_ChangeProviderLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vIcon = require('-!svg-react-loader!../../../../assets/images/change-provider/v.svg')({
  width: '10',
  height: '8',
  viewBox: '0 0 10 8'
});
var xIcon = require('-!svg-react-loader!../../../../assets/images/change-provider/x.svg')({
  width: '10',
  height: '10',
  viewBox: '0 0 10 10'
});

var cx = _bind2.default.bind(_comparisonTable2.default);

/* eslint-disable new-cap, react/prop-types */

var RowLayout = function (_Component) {
  (0, _inherits3.default)(RowLayout, _Component);

  function RowLayout(props) {
    (0, _classCallCheck3.default)(this, RowLayout);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RowLayout.__proto__ || (0, _getPrototypeOf2.default)(RowLayout)).call(this, props));

    _this.rowClick = _this.rowClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(RowLayout, [{
    key: 'get1',
    value: function get1() {
      return null;
    }
  }, {
    key: 'get2',
    value: function get2() {
      return null;
    }
  }, {
    key: 'get3',
    value: function get3() {
      return null;
    }
  }, {
    key: 'get4',
    value: function get4() {
      return null;
    }
  }, {
    key: 'get5',
    value: function get5() {
      return null;
    }
  }, {
    key: 'get6',
    value: function get6() {
      return null;
    }
  }, {
    key: 'after',
    value: function after() {
      return null;
    }
  }, {
    key: 'getRowProps',
    value: function getRowProps() {
      return {};
    }
  }, {
    key: 'rowClick',
    value: function rowClick() {}
  }, {
    key: 'render',
    value: function render() {
      var additionalRowClass = this.rowClass;
      var containerRowClass = this.comtainerRowClass;
      return _react2.default.createElement(
        'div',
        { className: containerRowClass },
        _react2.default.createElement(
          'div',
          {
            onClick: this.rowClick,
            className: cx(_comparisonTable2.default.row, (0, _defineProperty3.default)({}, additionalRowClass, additionalRowClass))
          },
          _react2.default.createElement(
            'div',
            null,
            this.get1()
          ),
          _react2.default.createElement(
            'div',
            null,
            this.get2()
          ),
          _react2.default.createElement(
            'div',
            null,
            this.get3()
          ),
          _react2.default.createElement(
            'div',
            null,
            this.get4()
          ),
          _react2.default.createElement(
            'div',
            null,
            this.get5()
          ),
          _react2.default.createElement(
            'div',
            null,
            this.get6()
          )
        ),
        this.after()
      );
    }
  }, {
    key: 'rowClass',
    get: function get() {
      return _comparisonTable2.default.comparisonRow;
    }
  }, {
    key: 'comtainerRowClass',
    get: function get() {
      return null;
    }
  }]);
  return RowLayout;
}(_react.Component);

var HeaderInfo = function HeaderInfo(props) {
  var provider = props.provider,
      openSupportDialog = props.openSupportDialog,
      t = props.t;

  var renderComponent = null;
  if (provider.supportLink) {
    renderComponent = _react2.default.createElement(
      _Tooltip2.default,
      {
        maxWidth: '304px',
        placement: 'bottom',
        textAlign: 'left',
        hideDelay: 400,
        content: _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_ChangeProviderLink2.default, {
            onClick: function onClick() {
              return openSupportDialog(provider.supportLink);
            },
            text: t.getByKey('ChangeProvider_Switch_Screen_OrderAPrint_Tooltip_Link')
          }),
          ' ',
          t.getByKey('ChangeProvider_Switch_Screen_OrderAPrint_Tooltip') + ' ' + t.getByKey(provider.languageKeys.nameCartKey),
          '.'
        )
      },
      _react2.default.createElement(
        'div',
        { className: _comparisonTable2.default.headerProviderInfo },
        (0, _dist.Info2)()
      )
    );
  }
  return renderComponent;
};

var HeaderRow = function (_RowLayout) {
  (0, _inherits3.default)(HeaderRow, _RowLayout);

  function HeaderRow() {
    (0, _classCallCheck3.default)(this, HeaderRow);
    return (0, _possibleConstructorReturn3.default)(this, (HeaderRow.__proto__ || (0, _getPrototypeOf2.default)(HeaderRow)).apply(this, arguments));
  }

  (0, _createClass3.default)(HeaderRow, [{
    key: 'getProviderHeader',
    value: function getProviderHeader(provider) {
      var t = this.props.t;
      var _provider$languageKey = provider.languageKeys,
          comparisonHeaderKey = _provider$languageKey.comparisonHeaderKey,
          nameKey = _provider$languageKey.nameKey;

      return [_react2.default.createElement(
        'span',
        { key: 1, className: _comparisonTable2.default.headerLine1 },
        t.getByKey(comparisonHeaderKey)
      ), _react2.default.createElement(
        'span',
        { key: 2, className: _comparisonTable2.default.headerLine2 },
        t.getByKey('ChangeProvider_Comparison_Chart_Fulfilled_By'),
        ':',
        ' ',
        t.getByKey(nameKey)
      )];
    }
  }, {
    key: 'get3',
    value: function get3() {
      var provider = this.props.providers[0];
      return this.getProviderHeader(provider, this.props.learnMore);
    }
  }, {
    key: 'get4',
    value: function get4() {
      var provider = this.props.providers[0];
      return _react2.default.createElement(HeaderInfo, {
        provider: provider,
        openSupportDialog: this.props.openSupportDialog,
        t: this.props.t
      });
    }
  }, {
    key: 'get5',
    value: function get5() {
      var provider = this.props.providers[1];
      return this.getProviderHeader(provider, this.props.learnMore);
    }
  }, {
    key: 'get6',
    value: function get6() {
      var provider = this.props.providers[1];
      return _react2.default.createElement(HeaderInfo, {
        provider: provider,
        openSupportDialog: this.props.openSupportDialog,
        t: this.props.t
      });
    }
  }, {
    key: 'rowClass',
    get: function get() {
      return _comparisonTable2.default.header;
    }
  }]);
  return HeaderRow;
}(RowLayout);

var ComparisonRow = function (_RowLayout2) {
  (0, _inherits3.default)(ComparisonRow, _RowLayout2);

  function ComparisonRow() {
    (0, _classCallCheck3.default)(this, ComparisonRow);
    return (0, _possibleConstructorReturn3.default)(this, (ComparisonRow.__proto__ || (0, _getPrototypeOf2.default)(ComparisonRow)).apply(this, arguments));
  }

  (0, _createClass3.default)(ComparisonRow, [{
    key: 'getContentForComparison',
    value: function getContentForComparison(provider, comparisonKey) {
      var comparisonValue = provider[comparisonKey];
      var content = null;
      if ((typeof comparisonValue === 'undefined' ? 'undefined' : (0, _typeof3.default)(comparisonValue)) === (0, _typeof3.default)(true)) {
        content = comparisonValue ? vIcon : xIcon;
      } else if ((typeof comparisonValue === 'undefined' ? 'undefined' : (0, _typeof3.default)(comparisonValue)) === (typeof undefined === 'undefined' ? 'undefined' : (0, _typeof3.default)(undefined))) {
        content = _react2.default.createElement(
          'span',
          { style: { fontWeight: '600', letterSpacing: '2px' } },
          'N/A'
        );
      }

      return content;
    }
  }, {
    key: 'get2',
    value: function get2() {
      var content = this.props.row.subCompare ? _react2.default.createElement(
        'b',
        null,
        this.props.row.text
      ) : this.props.row.text;
      return _react2.default.createElement(
        'span',
        null,
        content
      );
    }
  }, {
    key: 'get3',
    value: function get3() {
      var provider = this.props.providers[0];
      var comparisonKey = this.props.row.key;

      return this.getContentForComparison(provider, comparisonKey);
    }
  }, {
    key: 'get5',
    value: function get5() {
      var provider = this.props.providers[1];
      var comparisonKey = this.props.row.key;
      return this.getContentForComparison(provider, comparisonKey);
    }
  }, {
    key: 'comtainerRowClass',
    get: function get() {
      return _comparisonTable2.default.comparisonContainer;
    }
  }]);
  return ComparisonRow;
}(RowLayout);

var SubRow = function (_ComparisonRow) {
  (0, _inherits3.default)(SubRow, _ComparisonRow);

  function SubRow() {
    (0, _classCallCheck3.default)(this, SubRow);
    return (0, _possibleConstructorReturn3.default)(this, (SubRow.__proto__ || (0, _getPrototypeOf2.default)(SubRow)).apply(this, arguments));
  }

  (0, _createClass3.default)(SubRow, [{
    key: 'rowClass',
    get: function get() {
      return cx(_comparisonTable2.default.subRow, _comparisonTable2.default.comparisonRow);
    }
  }, {
    key: 'comtainerRowClass',
    get: function get() {
      return null;
    }
  }]);
  return SubRow;
}(ComparisonRow);

var ExpandableRow = function (_ComparisonRow2) {
  (0, _inherits3.default)(ExpandableRow, _ComparisonRow2);

  function ExpandableRow(props) {
    (0, _classCallCheck3.default)(this, ExpandableRow);

    var _this5 = (0, _possibleConstructorReturn3.default)(this, (ExpandableRow.__proto__ || (0, _getPrototypeOf2.default)(ExpandableRow)).call(this, props));

    _this5.expand = function (shouldExpand) {
      _this5.setState({ isExpanded: shouldExpand });
    };

    _this5.state = {
      isExpanded: false
    };
    return _this5;
  }

  (0, _createClass3.default)(ExpandableRow, [{
    key: 'rowClick',
    value: function rowClick() {
      this.expand(!this.state.isExpanded);
    }
  }, {
    key: 'get1',
    value: function get1() {
      return _react2.default.createElement(
        'div',
        { className: cx(_comparisonTable2.default.arrow, { collapsed: !this.state.isExpanded }) },
        (0, _arrow2.default)({ height: '6', width: '11' })
      );
    }
  }, {
    key: 'keep',
    value: function keep(el) {
      this.el = el;
    }
  }, {
    key: 'after',
    value: function after() {
      var _this6 = this;

      var _props = this.props,
          row = _props.row,
          providers = _props.providers;
      var subCompare = row.subCompare;

      var style = {
        height: '0px'
      };
      if (this.el && this.state.isExpanded) {
        style.height = this.el.scrollHeight + 'px';
      }
      return _react2.default.createElement(
        'div',
        { style: style, ref: function ref(el) {
            return _this6.keep(el);
          }, className: cx(_comparisonTable2.default.expandArea) },
        subCompare.map(function (compare, index) {
          return _react2.default.createElement(SubRow, { key: index, row: compare, providers: providers });
        })
      );
    }
  }, {
    key: 'rowClass',
    get: function get() {
      return cx(_comparisonTable2.default.expandRow, { exandedStyle: this.state.isExpanded });
    }
  }]);
  return ExpandableRow;
}(ComparisonRow);

var ComparisonTable = function ComparisonTable(props) {
  var comparisonRows = props.comparisonRows,
      providers = props.providers,
      learnMore = props.learnMore,
      openSupportDialog = props.openSupportDialog,
      t = props.t;


  return _react2.default.createElement(
    'div',
    { className: _comparisonTable2.default.container },
    _react2.default.createElement(HeaderRow, {
      providers: providers,
      learnMore: learnMore,
      openSupportDialog: openSupportDialog,
      t: t
    }),
    _react2.default.createElement(
      'div',
      { className: _comparisonTable2.default.content2 },
      comparisonRows.map(function (row, index) {
        if (row.subCompare) {
          return _react2.default.createElement(ExpandableRow, {
            key: index,
            row: row,
            providers: providers,
            t: t
          });
        } else {
          return _react2.default.createElement(ComparisonRow, {
            key: index,
            row: row,
            providers: providers,
            t: t
          });
        }
      })
    )
  );
};

ComparisonTable.propTypes = {};

/* eslint-enable new-cap, react/prop-types */

exports.default = ComparisonTable;